export { default } from './shortcut-links';
